import { Box, Flex, GridProps, mdBumps, Typo, xsBumps } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'

import { tDefaults } from '../../../../infrastructure/internationalisation'
import { InputConfig } from '../../../../state/configuration'
import { FormFormatter } from '../../FormFormatter'

export interface InputRepeaterSummaryProps extends GridProps {
  t: TFunction
  values: Record<'id' | string, string>
  elements: InputConfig[]
}

export const InputRepeaterSummary: FunctionComponent<InputRepeaterSummaryProps> = ({
  t,
  values,
  elements,
  ...props
}) =>
  elements.length ? (
    <Box
      p={mdBumps}
      width={1}
      backgroundColor='border'
      {...props}
      display='flex'
      flexDirection='column'
      rowGap={xsBumps}
    >
      {elements.map((element) => (
        <Flex key={element.name} columnGap={2} rowGap={xsBumps}>
          <Box width={[1 / 2, 1 / 2, 1 / 2, 1 / 3]}>
            <Typo whiteSpace='nowrap'>
              {t(tDefaults('product.headers', element.name))}
            </Typo>
          </Box>
          <Box width={[1 / 2, 1 / 2, 1 / 2, 2 / 3]}>
            <Typo whiteSpace='nowrap'>
              <FormFormatter t={t} input={element} value={values[element.name]} />
            </Typo>
          </Box>
        </Flex>
      ))}
    </Box>
  ) : null
